var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShoppingCart = function SvgShoppingCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "34px",
    viewBox: "0 0 42 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purchase",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-11-Copy",
    fill: "#FFFFFF",
    transform: "translate(14.348038, 29.829957) scale(-1, 1) translate(-14.348038, -29.829957) ",
    cx: 14.3480376,
    cy: 29.8299567,
    r: 2.84004334
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-11-Copy-2",
    fill: "#FFFFFF",
    transform: "translate(30.381300, 29.829957) scale(-1, 1) translate(-30.381300, -29.829957) ",
    cx: 30.3813001,
    cy: 29.8299567,
    r: 2.84004334
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.123755, 0.491639)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.42
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-13",
    transform: "translate(5.018137, 9.307460) scale(-1, 1) translate(-5.018137, -9.307460) ",
    points: "0.037455957 18.321301 3.98817293 0.293619847 9.99881714 0.293619847"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-15",
    stroke: "#FFFFFF",
    strokeWidth: 2.42,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "7.43826492 6.58888517 37.9823364 6.71342469 34.3523364 21.2334247 10.5936291 21.0455269"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart.27221066.svg";
export { ForwardRef as ReactComponent };